const apis = {
  getSoftVersion: '/api/tp/software/getNewestSoftwareLitVersion/',
  getSoftDetails: '/api/tp/software/getAllAvailable/',
  getSoftTypes: '/api/tp/st/getAllAvailable/',
  getRecommendSoftware: '/api/tp/user/getRecommendSoftware',
  getAuthNode: 'api/tp/user/getAuthNode',
  getUserInfo: '/api/tp/user/check',
  getInternetAuth: '/api/tp/user/getInternetAuth',
  getVoteSoft: '/api/tp/user/getVoteSoft',
  voteSoft: '/api/tp/user/voteSoft',
  getSoftRankingList: '/api/tp/usae/getSoftRankingList',
  authSoftApply: '/api/tp/usa/add',
  authSoftQuery: '/api/tp/usa/query',
  adobeAll: '/api/tp/usa/adobeAll',
  getLeaderAndCostCenter: '/api/tp/usa/getLeaderAndCostCenter',
  isRelateSoftware: '/api/tp/usa/isRelateSoftware',
  isLightApprove: '/api/tp/usa/isLightApprove',
  urgeActive: '/api/tp/usa/urgeActive',
  softTaskCreate: '/api/tp/task/create',
  getTripPc: '/api/tp/common/getTripPc/',
  getCheckInfo: '/api/tp/tools/getCheckInfo/',
  dataClearCheck: '/api/tp/tools/dataClearCheck/',
  saveLog: '/api/tp/log/add',
  versionLog: '/api/tp/psv/update',
  getLanguages: '/api/tp/sys/language',
  hwCheck: '/api/tp/hw/check',
  softwareApplication: '/api/tp/usae/',
  getPcGrantTime: '/api/tp/computer/getPcGrantTime/',
  reportError: '/api/tp/computer/reportError',
  getSoftware: '/api/tp/software/searchSoftware',
  getUserLicense: '/api/tp/user/getUserLicense',
  callInTest: 'api/tp/user/callInTest',
  callInTestQuery: 'api/tp/user/callInTestQuery',
  callOutTest: 'api/tp/user/callOutTest',
  callOutTestQuery: 'api/tp/user/callOutTestQuery',
  getLicenseStock: 'api/tp/sa/getLicenseStock',
  recycleLicense: 'api/tp/sa/recycleLicense',
  pcAdmin: 'api/tp/ua/pcAdmin', // admin apply
  getPcAdminApply: 'api/tp/ua/getPcAdminApply', // admin apply
  getUserLeaderFive: 'api/tp/ua/getUserLeader5',
  getUpdateInfo: '/api/tp/software/getOtherAvailable/update',
  getVersionHash: '/api/tp/software/getVersionHash',
  checkAdminReboot: '/api/tp/user/checkAdminReboot',
  getVersionHashList: '/api/tp/software/getVersionHashList',
  syncSelfHelp: '/api/tp/log/selfHelpSync',
  checkGrayDevice: '/api/tp/user/checkGrayDevice',
  getFigmaPermission: '/api/tp/usa/figmaPermission',
};

export default apis;
